import React from "react";
import { cn } from "../cn";

export type SectionLabelProps = React.HTMLAttributes<HTMLElement> & {
  /** Render as a real heading when the label introduces a landmark section. */
  as?: "span" | "h2" | "h3" | "h4";
  children: React.ReactNode;
};

/**
 * The `overline` type role: a short, uppercase label above a group of content.
 *
 * It replaces the old `zen-label`, which was 10px, `tracking-[0.3em]` and
 * indigo at 70% opacity — 4.03:1, and unreadable at that size. This is 12px at
 * weight 600 in `content-secondary` (7.69:1), with tracking cut to 0.08em.
 *
 * Keep the text to four words or fewer. Uppercase runs of prose read slowly,
 * which is why the old label being used for patient names and dates was a
 * problem beyond contrast.
 */
const SectionLabel: React.FC<SectionLabelProps> = ({
  as: Tag = "span",
  className,
  children,
  ...rest
}) => (
  <Tag
    className={cn(
      "block text-xs font-semibold uppercase tracking-[0.08em] text-content-secondary",
      className
    )}
    {...rest}
  >
    {children}
  </Tag>
);

export default SectionLabel;
